import React from 'react';

export default function Spinner({ size = 'md', label = 'Cargando...' }) {
  const sizeMap = {
    sm: { core: 32, ring1: 32, ring2: 24, center: 8 },
    md: { core: 48, ring1: 48, ring2: 36, center: 12 },
    lg: { core: 64, ring1: 64, ring2: 48, center: 16 },
  };

  const config = sizeMap[size] || sizeMap.md;
  const ring2Offset = (config.ring1 - config.ring2) / 2;

  return (
    <div className="flex flex-col items-center justify-center">
      <div className="relative" style={{ width: config.core, height: config.core }}>
        <div
          style={{
            position: 'absolute',
            width: '100%',
            height: '100%',
            borderRadius: '50%',
            borderWidth: '2px',
            borderColor: 'transparent',
            borderTopColor: 'var(--color-primary-500, #5b9ef5)',
            borderRightColor: 'var(--color-primary-500, #5b9ef5)',
            animation: 'spin-ring 2s linear infinite',
          }}
        />

        <div
          style={{
            position: 'absolute',
            width: config.ring2,
            height: config.ring2,
            top: ring2Offset,
            left: ring2Offset,
            borderRadius: '50%',
            borderWidth: '2px',
            borderColor: 'transparent',
            borderTopColor: 'var(--color-primary-400, #7eb3fa)',
            borderBottomColor: 'var(--color-primary-400, #7eb3fa)',
            animation: 'spin-ring 1.5s linear infinite reverse',
          }}
        />

        <div
          style={{
            position: 'absolute',
            width: config.center,
            height: config.center,
            background: 'linear-gradient(135deg, var(--color-primary-500, #5b9ef5) 0%, var(--color-primary-700, #2563eb) 100%)',
            borderRadius: '50%',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            boxShadow: '0 0 12px var(--color-primary-400, #7eb3fa)',
            animation: 'pulse-dot 2s ease-in-out infinite',
          }}
        />
      </div>

      {label && (
        <div
          className="mt-3 text-xs font-semibold uppercase tracking-wide dark:text-slate-300"
          style={{
            background: 'linear-gradient(90deg, rgb(100, 116, 139) 0%, var(--color-primary-500, #5b9ef5) 50%, rgb(100, 116, 139) 100%)',
            backgroundSize: '1000px 100%',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            backgroundClip: 'text',
            animation: 'shimmer 2s infinite',
          }}
        >
          {label}
        </div>
      )}
    </div>
  );
}